import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Table, Row, Col, Card, CardBody, Container } from 'reactstrap';
import { TablePagination } from '../../Components/Pagination'
import amazonLogo from '../../Assets/images/icons/Amazon_logo.svg 1.png'
import carrefourLogo from '../../Assets/images/icons/carrefour.png'
import { getAllUsers } from '../../API/Backend';
import { showToast } from '../../Components/Toast';
import Skeleton from "react-loading-skeleton";
import Image from '../../Components/Image'

const products = [
  {
    image: 'https://m.media-amazon.com/images/I/61qP3bB+yAL._AC_SL1200_.jpg',
    product: 'Dog Food, Chicken & Chicken Liver Recipe...',
    amazonPrice: '$100/-',
    carrefourPrice: '$120/-'
  },
  {
    image: 'https://m.media-amazon.com/images/I/61PubYwrTCL._AC_SL1000_.jpg',
    product: 'Grain Free Dry Dog Food | Rachael Ray Nutrish',
    amazonPrice: '$100/-',
    carrefourPrice: '$120/-'
  },
  {
    image: 'https://m.media-amazon.com/images/I/61TVYHlK8fS._AC_SL1024_.jpg',
    product: 'Weruva Pumpkin Patch Up! Pumpkin With Ginger...',
    amazonPrice: '$100/-',
    carrefourPrice: '$120/-'
  },
];

const CartDetails = () => {
  const [cart, setCart] = useState([]);
  const [loading, setLoading] = useState(false);
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(1);
  const [count, setCount] = useState(0);
  const params = useParams();
  const id = params.id;

  useEffect(() => {
    fetchCart();
  }, [])

  const fetchCart = (limit = 10, offset = 0, keyword = "") => {
    setLoading(true)
    setCart([])
    getAllUsers({ limit: limit, offset: offset, ...(keyword && keyword.length && { search: keyword }) }, id).then(({ data }) => {
      if (data.data) {
        console.log('cart', data.data[0].items)
        setCart(data.data ? data.data[0].items : [])
        // setCount(data.data ? data.data.count : 0)
      }
      else {
        showToast("error", "Request Failed", data.message)
      }
      setLoading(false)
    }).catch((err) => {
      showToast("error", "Request Failed", err.message)
      setLoading(false)
    })
  }

  const onPaginationChange = (currentPage) => {
    if (page !== currentPage) {
      setPage(currentPage);
      fetchCart(limit, limit * (currentPage - 1), "")
    }
  }

  return (
    <Container fluid>
      <Row>
        <Col>
          <h5 className="page-title">Cart</h5>
          <Card>
            <CardBody>
              <Row className="mb-3">
                <Col md="12">
                  <div className='d-flex align-items-center gap-5'>
                    <div className='table-size-container'>
                      <span>Showing</span>
                      <select className='table-size-control' value={limit} onChange={(e) => { setLimit(Number(e.target.value)); fetchCart(Number(e.target.value), 0, "") }}>
                        <option value="10">10</option>
                        <option value="25">25</option>
                        <option value="50">50</option>
                      </select>
                      <span>entries</span>
                    </div>
                    <div className="table-search-box">
                      <input type="search" id="customSearch" placeholder="Search Here..." />
                      <button><i className="ri-search-line"></i></button>
                    </div>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Table>
                    <thead>
                      <tr>
                        <th className='w-20'>Image</th>
                        <th className='w-40'>Product</th>
                        <th className='w-10 text-center'>Quantity</th>
                        <th className='w-15'><img src={amazonLogo} alt="Amazon" /></th>
                        <th className='w-15'><img src={carrefourLogo} alt="Carrefour" /></th>
                      </tr>
                    </thead>
                    <tbody>
                      {
                        loading ?
                          [...Array(15)].map((a, i) => {
                            return <tr key={i}>
                              <td className='w-20'><div><Skeleton height={40} width={80} className='me-2' /></div></td>
                              <td className='w-40'><Skeleton height={12} width={80} /></td>
                              <td className='w-10 text-center'><Skeleton height={12} width={80} /></td>
                              <td className='w-15'><Skeleton height={20} width={60} /></td>
                              <td className='w-15'><Skeleton height={30} width={60} /></td>
                            </tr>
                          }) :
                          !cart.length ?
                            <tr><td colSpan="5" className="text-center fs-12 fw-600"><span className="d-flex align-items-center justify-content-center"><i className="ri-error-warning-line text-danger fs-22 fw-300 me-2"></i> No cart items found</span></td></tr> :
                            cart.map((item, i) => (
                              <tr key={i}>
                                <td className='w-20'><Image src={item.productId.image} alt="Banner" className='me-2' height='40px' width='70px' objectFit='cover' /></td>
                                <td className='w-40'>{item.productId.title}</td>
                                <td className='w-10 text-center'>{item.quantity}</td>
                                <td className='w-15'><a href={item.productId.amazonLink} target='_blank' className='text-dark text-decoration-none'><strong>$ {item.productId.amazonPrice}/-</strong></a></td>
                                <td className='w-15'><a href={item.productId.carrefourLink} target='_blank' className='text-dark text-decoration-none'><strong>$ {item.productId.carrefourPrice}/-</strong></a></td>
                              </tr>
                            ))
                      }
                    </tbody>
                  </Table>
                </Col>
              </Row>
              {/* <TablePagination limit={1} page={2} currentRecords={1} total={3} loading={false} onPaginationChange={(p) => console.log(p)} /> */}
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default CartDetails;
